import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from './context/ThemeContext';

// Clean up old session data (one-time migration)
// Only run if old data exists
const cleanupKey = '_cleanup_done';
if (!sessionStorage.getItem(cleanupKey)) {
  try {
    if (localStorage.getItem('user')) {
      localStorage.removeItem('user');
    }
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
    }
    sessionStorage.setItem(cleanupKey, 'true');
  } catch (e) {

  }
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ThemeProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);

// Service worker disabled to prevent stale caches during auth flows

reportWebVitals();
